import React from 'react'
import { ICSDrawerContents } from "@ntg/component-library/declarations";
import HomeIcon from "@mui/icons-material/Home";
import PortraitIcon from "@mui/icons-material/Portrait";

export const DrawerContents: ICSDrawerContents = {
    Items: [
        {
            DrawerItems: [
                {
                    Icon: <HomeIcon color="secondary" />,
                    PrimaryText: "Home",
                    ShowMobile: true,
                    To: "/home",
                }
            ],
            ShowTitle: false,
            Title: "",
        },
        {
            DrawerItems: [
                {
                    Icon: <PortraitIcon color="secondary" />,
                    PrimaryText: "Test Page",
                    ShowMobile: true,
                    To: "/test",
                }
            ],
            ShowTitle: true,
            Title: "TEST",
        }
    ]
};